<template>
  <div class="layout-container" :class="{ 'layout-container__survey-sm-col': isSurveySmallCol, 'layout-container__survey-md-col': isSurveyMediumCol,'responsive': responsive }">
    <div class="d-flex flex-column layout-container__left">
      <div class="d-flex flex-column">
        <div class="d-flex align-items-center">
          <slot name="titleIcon"></slot>
          <span class="title">{{ title }}</span>
        </div>
        <slot name="description"></slot>
      </div>
      <div class="d-flex flex-column" v-if="subTitle">
        <span class="sub-title">{{ subTitle }}</span>
      </div>
      <slot name="leftContent"></slot>
    </div>
    <div class="layout-container__right">
      <slot name="rightContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UninstallLayout',
  props: {
    title: String,
    subTitle: String,
    subTitleDesc: String,
    isSurveyMediumCol: Boolean,
    isSurveySmallCol: Boolean,
    isAutoCol: Boolean,
    responsive: Boolean
  },
}
</script>

<style scoped lang="scss">
  $column_width: 588px;
  $column_right_width_md: 540px;
  $column_right_width_sm: 480px;

  $column_survey_width_md: 720px;
  $column_survey_width_sm: 700px;
  .layout-container {
    margin-top: 80px;
    margin-bottom: 74px;
    gap: 24px;
    display: grid;
    grid-template-columns: repeat(2 , $column_width);
    justify-content: center;

    &__survey-md-col {
      grid-template-columns:  $column_survey_width_md $column_right_width_sm;
    }

    &__survey-sm-col {
      grid-template-columns: $column_survey_width_sm $column_right_width_sm;
    }

    &__left {
      gap: 32px;
    }
  }
  .title {
    color: $textLightModeHigh;
    font-size: 32px;
    font-weight: 600;
    line-height: 120%;
  }
  
  .sub-title {
    color: $textLightModeHigh;
    font-size: 18px;
    font-weight: 600;
    line-height: 120%;
  }

  @media only screen and (max-width: 1360px) {
    .layout-container {
      margin-left: 80px;
      margin-right: 80px;
      justify-content: start;
      &.responsive {
        grid-template-columns: auto $column_width;
      }
    }
  }
</style>
